export const isValidUrl = (url: string): boolean => {
  try {
    const urlObj = new URL(url);
    return urlObj.protocol === "http:" || urlObj.protocol === "https:";
  } catch {
    return false;
  }
};

export const validateButtonLink = (link: string): boolean => {
  if (!link) return false;
  return isValidUrl(link);
};
